export var ValidationOperation;
(function (ValidationOperation) {
    ValidationOperation["TransferClient"] = "transferClient";
    ValidationOperation["SendToWellSky"] = "sendToWellSky";
})(ValidationOperation || (ValidationOperation = {}));
export var ValidationFieldSource;
(function (ValidationFieldSource) {
    ValidationFieldSource["CoreHomeCareLeadField"] = "coreHomeCareLeadField";
    ValidationFieldSource["IntakeQuestion"] = "intakeQuestion";
})(ValidationFieldSource || (ValidationFieldSource = {}));
export var ValidationRuleSeverity;
(function (ValidationRuleSeverity) {
    ValidationRuleSeverity["Hard"] = "hard";
    ValidationRuleSeverity["Warning"] = "warning";
})(ValidationRuleSeverity || (ValidationRuleSeverity = {}));
export var ValidationRuleType;
(function (ValidationRuleType) {
    ValidationRuleType["Required"] = "required";
})(ValidationRuleType || (ValidationRuleType = {}));
export var CoreHomeCareLeadValidationField;
(function (CoreHomeCareLeadValidationField) {
    CoreHomeCareLeadValidationField["ClientName"] = "clientName";
    CoreHomeCareLeadValidationField["ClientPreferredName"] = "clientPreferredName";
    CoreHomeCareLeadValidationField["ClientCellPhone"] = "clientCellPhone";
    CoreHomeCareLeadValidationField["ClientPhone"] = "clientPhone";
    CoreHomeCareLeadValidationField["ClientEmail"] = "clientEmail";
    CoreHomeCareLeadValidationField["ClientAddress"] = "clientAddress";
    CoreHomeCareLeadValidationField["ClientCity"] = "clientCity";
    CoreHomeCareLeadValidationField["ClientState"] = "clientState";
    CoreHomeCareLeadValidationField["ClientZip"] = "clientZip";
    CoreHomeCareLeadValidationField["ClientDateOfBirth"] = "clientDateOfBirth";
    CoreHomeCareLeadValidationField["BestContactName"] = "bestContactName";
    CoreHomeCareLeadValidationField["BestContactPreferredName"] = "bestContactPreferredName";
    CoreHomeCareLeadValidationField["BestContactCellPhone"] = "bestContactCellPhone";
    CoreHomeCareLeadValidationField["BestContactPhone"] = "bestContactPhone";
    CoreHomeCareLeadValidationField["BestContactEmail"] = "bestContactEmail";
    CoreHomeCareLeadValidationField["BestContactAddress"] = "bestContactAddress";
    CoreHomeCareLeadValidationField["BestContactCity"] = "bestContactCity";
    CoreHomeCareLeadValidationField["BestContactState"] = "bestContactState";
    CoreHomeCareLeadValidationField["BestContactZip"] = "bestContactZip";
    CoreHomeCareLeadValidationField["EstimatedStartDate"] = "estimatedStartDate";
    CoreHomeCareLeadValidationField["HoursPerWeek"] = "hoursPerWeek";
    CoreHomeCareLeadValidationField["DaysNeeded"] = "daysNeeded";
})(CoreHomeCareLeadValidationField || (CoreHomeCareLeadValidationField = {}));
export const CoreHomeCareLeadValidationFieldBridgePathsFromHomeCareLeadEntity = {
    [CoreHomeCareLeadValidationField.ClientName]: "selfContactEntity.name",
    [CoreHomeCareLeadValidationField.ClientPreferredName]: "selfContactEntity.preferredName",
    [CoreHomeCareLeadValidationField.ClientCellPhone]: "selfContactEntity.cellPhone",
    [CoreHomeCareLeadValidationField.ClientPhone]: "selfContactEntity.phone1",
    [CoreHomeCareLeadValidationField.ClientEmail]: "selfContactEntity.email1",
    [CoreHomeCareLeadValidationField.ClientAddress]: "selfContactEntity.address1",
    [CoreHomeCareLeadValidationField.ClientCity]: "selfContactEntity.city",
    [CoreHomeCareLeadValidationField.ClientState]: "selfContactEntity.state",
    [CoreHomeCareLeadValidationField.ClientZip]: "selfContactEntity.zip",
    [CoreHomeCareLeadValidationField.ClientDateOfBirth]: "selfContactEntity.birthday",
    [CoreHomeCareLeadValidationField.BestContactName]: "bestContactEntity.name",
    [CoreHomeCareLeadValidationField.BestContactPreferredName]: "bestContactEntity.preferredName",
    [CoreHomeCareLeadValidationField.BestContactCellPhone]: "bestContactEntity.cellPhone",
    [CoreHomeCareLeadValidationField.BestContactPhone]: "bestContactEntity.phone1",
    [CoreHomeCareLeadValidationField.BestContactEmail]: "bestContactEntity.email1",
    [CoreHomeCareLeadValidationField.BestContactAddress]: "bestContactEntity.address1",
    [CoreHomeCareLeadValidationField.BestContactCity]: "bestContactEntity.city",
    [CoreHomeCareLeadValidationField.BestContactState]: "bestContactEntity.state",
    [CoreHomeCareLeadValidationField.BestContactZip]: "bestContactEntity.zip",
    [CoreHomeCareLeadValidationField.EstimatedStartDate]: "estimatedStartDate",
    [CoreHomeCareLeadValidationField.HoursPerWeek]: "hoursPerWeek",
    [CoreHomeCareLeadValidationField.DaysNeeded]: "daysNeeded",
};
//# sourceMappingURL=validation-rule.js.map